import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import Routes from './modules/Routes/Routes';

import store from './store';

import { loadBaseUrl } from './utils/axiosAPI';

import './polyfills';
import './font-awesome';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

loadBaseUrl();

ReactDOM.render(
  <Provider store={store}>
    <Routes />
  </Provider>,
  document.getElementById('root')
);
